import { render, staticRenderFns } from "./reservaInfoM.vue?vue&type=template&id=430083f7"
import script from "./reservaInfoM.vue?vue&type=script&lang=js"
export * from "./reservaInfoM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports